/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sovereign_Protection_ProtocolInputs */

const en_sovereign_protection_protocol = /** @type {(inputs: Sovereign_Protection_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign Protection Protocol`)
};

const es_sovereign_protection_protocol = /** @type {(inputs: Sovereign_Protection_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protocolo de protección Sovereign`)
};

const fr_sovereign_protection_protocol = /** @type {(inputs: Sovereign_Protection_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protocole de protection Sovereign`)
};

const de_sovereign_protection_protocol = /** @type {(inputs: Sovereign_Protection_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign Schutzprotokoll`)
};

const ja_sovereign_protection_protocol = /** @type {(inputs: Sovereign_Protection_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign 保護プロトコル`)
};

const zh_sovereign_protection_protocol = /** @type {(inputs: Sovereign_Protection_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign 保护协议`)
};

const ar_sovereign_protection_protocol = /** @type {(inputs: Sovereign_Protection_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بروتوكول حماية Sovereign`)
};

const id_sovereign_protection_protocol = /** @type {(inputs: Sovereign_Protection_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protokol Perlindungan Sovereign`)
};

const it_sovereign_protection_protocol = /** @type {(inputs: Sovereign_Protection_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protocollo di Protezione Sovereign`)
};

const ru_sovereign_protection_protocol = /** @type {(inputs: Sovereign_Protection_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Протокол защиты Sovereign`)
};

const pt_sovereign_protection_protocol = /** @type {(inputs: Sovereign_Protection_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protocolo de Proteção Sovereign`)
};

const ko_sovereign_protection_protocol = /** @type {(inputs: Sovereign_Protection_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign 보호 프로토콜`)
};

/**
* | output |
* | --- |
* | "Sovereign Protection Protocol" |
*
* @param {Sovereign_Protection_ProtocolInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const sovereign_protection_protocol = /** @type {((inputs?: Sovereign_Protection_ProtocolInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sovereign_Protection_ProtocolInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sovereign_protection_protocol(inputs)
	if (locale === "es") return es_sovereign_protection_protocol(inputs)
	if (locale === "fr") return fr_sovereign_protection_protocol(inputs)
	if (locale === "de") return de_sovereign_protection_protocol(inputs)
	if (locale === "ja") return ja_sovereign_protection_protocol(inputs)
	if (locale === "zh") return zh_sovereign_protection_protocol(inputs)
	if (locale === "ar") return ar_sovereign_protection_protocol(inputs)
	if (locale === "id") return id_sovereign_protection_protocol(inputs)
	if (locale === "it") return it_sovereign_protection_protocol(inputs)
	if (locale === "ru") return ru_sovereign_protection_protocol(inputs)
	if (locale === "pt") return pt_sovereign_protection_protocol(inputs)
	return ko_sovereign_protection_protocol(inputs)
});